import React from 'react';
import styles from './styles.scss';

function DesignerForm ({
  websiteURL,
  dribbbleURL,
  employer,
  availability,
  designTypes,
  hourlyRate,
  processDescription,
  onChangeField
}) {
  return (
    <div className="container-fluid main-container">
      <div className="col-md-10 col-md-offset-1 col-sm-12">
        <div className="row">
          <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
            <div className="form-group">
              <label className="bold" htmlFor="websiteURL">YOUR PERSONAL SITE</label>
              <input
                type="text"
                className="form-control input-lg"
                id="websiteURL"
                placeholder="www.YOURSITE.com"
                name="websiteURL"
                value={websiteURL}
                onChange={onChangeField}
              />
            </div>
            <div className="form-group">
              <label className="bold" htmlFor="dribbbleURL">YOUR DRIBBBLE URL</label>
              <input
                type="text"
                className="form-control input-lg"
                id="dribbbleURL"
                placeholder="www.dribbble.com/YOURNAME"
                name="dribbbleURL"
                value={dribbbleURL}
                onChange={onChangeField}
              />
            </div>
            <div className="form-group">
              <label className="bold" htmlFor="employer">WHO IS YOUR CURRENT OR LAST EMPLOYER?</label>
              <input
                type="text"
                className="form-control input-lg"
                id="employer"
                placeholder="Enter employer info"
                name="employer"
                value={employer}
                onChange={onChangeField}
              />
            </div>
            <div className="form-group">
              <div className="form-label bold">WEEKLY AVAILABILITY</div>
              <div className="row">
                <div className="col-sm-10">
                  <div className="row">
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${availability === 'Part-Time' ? 'inverse' : ''}`}>
                        Part-Time
                        <input
                          type="radio"
                          id="availability"
                          name="availability"
                          value="Part-Time"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${availability === 'Full-Time' ? 'inverse' : ''}`}>
                        Full-Time
                        <input
                          type="radio"
                          id="availability"
                          name="availability"
                          value="Full-Time"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="form-label bold">TYPE OF DESIGN (SELECT YOUR BEST TWO)</div>
              <div className="row">
                <div className="col-sm-10">
                  <div className={`row mb10 ${styles.radioSelection}`}>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${designTypes.includes('Mobile UI') ? 'inverse' : ''}`}>
                        Mobile UI
                        <input
                          type="checkbox"
                          id="designTypes"
                          name="designTypes"
                          value="Mobile UI"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${designTypes.includes('Web UI') ? 'inverse' : ''}`}>
                        Web UI
                        <input
                          type="checkbox"
                          id="designTypes"
                          name="designTypes"
                          value="Web UI"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                  <div className={`row mb10 ${styles.radioSelection}`}>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${designTypes.includes('Logo/Branding') ? 'inverse' : ''}`}>
                        Logo / Branding
                        <input
                          type="checkbox"
                          id="designTypes"
                          name="designTypes"
                          value="Logo/Branding"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${designTypes.includes('Illustration') ? 'inverse' : ''}`}>
                        Illustration
                        <input
                          type="checkbox"
                          id="designTypes"
                          name="designTypes"
                          value="Illustration"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                  <div className={`row mb10 ${styles.radioSelection}`}>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${designTypes.includes('Animation') ? 'inverse' : ''}`}>
                        Animation
                        <input
                          type="checkbox"
                          id="designTypes"
                          name="designTypes"
                          value="Animation"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="form-label bold">WHAT IS YOUR TYPICAL HOURLY RATE?</div>
              <div className="row">
                <div className="col-sm-10">
                  <div className={`row mb10 ${styles.radioSelection}`}>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${hourlyRate === '$50-75' ? 'inverse' : ''}`}>
                        $50-75
                        <input
                          type="radio"
                          id="hourlyRate"
                          name="hourlyRate"
                          value="$50-75"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${hourlyRate === '$75-110' ? 'inverse' : ''}`}>
                        $75-110
                        <input
                          type="radio"
                          id="hourlyRate"
                          name="hourlyRate"
                          value="$75-110"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                  <div className={`row mb10 ${styles.radioSelection}`}>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${hourlyRate === '$110-125' ? 'inverse' : ''}`}>
                        $110-125
                        <input
                          type="radio"
                          id="hourlyRate"
                          name="hourlyRate"
                          value="$110-125"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${hourlyRate === '$150+' ? 'inverse' : ''}`}>
                        $150+
                        <input
                          type="radio"
                          id="hourlyRate"
                          name="hourlyRate"
                          value="$150+"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="bold" htmlFor="processDescription">
                DESCRIBE YOUR PROCESS IN DESIGNING A WEB OR MOBILE APP:
              </label>
              <textarea
                className="form-control input-lg"
                rows="5"
                id="processDescription"
                placeholder="Enter your process"
                name="processDescription"
                value={processDescription}
                onChange={onChangeField}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DesignerForm;



// WEBPACK FOOTER //
// ./src/components/DesignerForm/index.js